export default __webpack_public_path__ + "static/media/12.1f1b9736.png";